import React from "react";
import PropTypes from "prop-types";
import Countdown from "react-countdown";

const PawWarzCountdown = (props) => {
  const countdownRenderer = ({ days, hours, minutes, seconds }) => {
    let v = [];
    if (days > 0) {
      v.push(
        <span key="countdown-days">
          <i>{days}</i>&nbsp;days{" "}
        </span>
      );
    }
    if (hours > 0 || days > 0) {
      v.push(
        <span key="countdown-hours">
          <i>{hours}</i>&nbsp;hours{" "}
        </span>
      );
    }
    if (minutes > 0 || hours > 0 || days > 0) {
      v.push(
        <span key="countdown-minutes">
          <i>{minutes}</i>&nbsp;minutes{" "}
        </span>
      );
    }
    if (props.seconds) {
      v.push(
        <span key="countdown-seconds">
          <i>{seconds}</i>&nbsp;seconds{" "}
        </span>
      );
    }
    return v;
  };

  return (
    <span className="countdown">
      <Countdown {...props} renderer={countdownRenderer} />
    </span>
  );
};

PawWarzCountdown.propTypes = {
  seconds: PropTypes.bool,
};

PawWarzCountdown.defaultProps = {
  seconds: true,
};

export default PawWarzCountdown;
